<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
import {provide, ref, watch} from 'vue';

export const OpenPanel = Symbol()

export default {
  name: 'accordion',
  setup(props) {
    const openPanel = ref(null)
    provide(OpenPanel, openPanel)

    if (props.singleOnly) {
      watch(openPanel, (newVal, oldVal) => {
        if (oldVal && newVal && oldVal !== newVal) {
          oldVal.value = false
        }
      }, {deep: true})
    }
    return {}
  },
  props: {
    singleOnly: {
      type: Boolean,
      default: true
    }
  }
}
</script>